import React, { useEffect, useState } from 'react';
import { Input, MultiSelect, MultiSelectOption } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import ErrorIcon from '../../../../assets/error.png';
import isEmpty from 'lodash/isEmpty';
import { convertArrayToString, convertStringToArray } from '../../../../utils';

export type MapStatePropsType = { selectData: any };

export type DispatchPropsType = {
	validateNumber: (data: any, cb: (res: any) => void) => void;
	fetchFilters: (cb: any) => void;
};

export type CustomerNumberPropsType = {
	value: any;
	enableMasking?:boolean,
	onChange: (num: string) => void;
	setDisable: (val: any) => void;
	oneNumber: boolean;
	modeFilter?: boolean;
};

const CustomerNumber: React.FC<
	MapStatePropsType & DispatchPropsType & CustomerNumberPropsType
> = ({
	validateNumber,
	value,
	onChange,
	setDisable,
	oneNumber,
	modeFilter = false,
	selectData,
	enableMasking,
	fetchFilters,
}) => {
		const { t } = useTranslation();
		const [customerNumber, setCustomerNumber] = useState<any>(value);
		const [change, setChange] = useState<any>({});
		const [customerNumbers, setCustomerNumbers] = useState<string[]>([]);
		const [custData, setCustData] = useState<string[]>([]);

		const getCountOfNumbers = (values: string) => {
			if (values?.length) {
				const numbers = values.split(',');
				return numbers?.length;
			}
			return 0;
		};
		const validateAPI = (values: string) => {
			validateNumber(
				{
					number: encodeURI(values),
				},
				(res) => {
					if (res?.code === '200') {
						setChange({
							...change,
							customerNumValid: true,
						});
						setDisable({
							...change,
							customerNumValid: true,
						});
					} else {
						setChange({
							...change,
							customerNumValid: false,
						});
						setDisable({
							...change,
							customerNumValid: false,
						});
					}
				}
			);
		};

		const validateNumbers = (values: any = undefined) => {
			if (modeFilter) {
				if (values) {
					validateAPI(values);
				} else {
					let numbersEntry = convertArrayToString(customerNumbers);
					validateAPI(numbersEntry);
				}
			} else {
				validateAPI(customerNumber);
			}
		};

		useEffect(() => {
			fetchFilters((res: any) => {
				if (!isEmpty(res)) {
					setCustData(res?.data?.customer_number);
				}
			});
		}, [fetchFilters]);

		const multiSelectValidation = (values: any) => {
			let regex = /^\+?(\d{0,14},)*(\+?\d{0,14}(?:,|$))+$/;
			if (!values?.length) {
				delete change.customerNumValid;
				setDisable({});
			}
			if (!oneNumber && values.length > 10) return;
			values.forEach((element: any) => {
				if (element && !regex.test(element)) return;
			});

			setCustomerNumbers(values);
			onChange(values);
		};
		return (
			<>
				{!modeFilter ? (
					<Input
						value={customerNumber}
						label={t('customerNum')}
						placeholder={t('customerNum')}
						className={Styles.ipElement}
						onChange={(e) => {
							let value = e.target.value;
							let regex;
							if (!value?.length) {
								delete change.customerNumValid;
								setDisable({});
							}
							if (oneNumber) {
								regex = /^\+?\d{0,14}$/;
							} else {
								regex = /^\+?(\d{0,14},)*(\+?\d{0,14}(?:,|$))+$/;
							}

							if (value && !regex.test(value)) return;

							if (!oneNumber && getCountOfNumbers(value) > 10) return;
							setCustomerNumber(value);
							onChange(value);
						}}
						onKeyDown={(e)=>{
							if(enableMasking && e.key === "Backspace" && customerNumber && customerNumber.indexOf('*') >= 0){
								setCustomerNumber('');
							}
						}}
						onBlur={() => {
							if(enableMasking && customerNumber && customerNumber.indexOf('*')>=0) return;
							if (modeFilter) {
								if (customerNumber?.length) {
									validateNumbers();
								}
							} else {
								validateNumbers();
							}
						}}
						bottomLabelType={
							change.hasOwnProperty('customerNumValid')
								? change['customerNumValid']
									? undefined
									: 'error'
								: undefined
						}
						bottomLabel={
							change.hasOwnProperty('customerNumValid') ? (
								change['customerNumValid'] ? undefined : (
									<span>
										<img
											style={{ marginRight: '0.5rem' }}
											src={ErrorIcon}
											className={Styles.errorIcon}
											alt=""
										/>
										{t('validCountryMsg')}
									</span>
								)
							) : undefined
						}
						showBottomLabelSpace={false}
					/>
				) : (
						<MultiSelect
							selectedValues={customerNumbers}
							onChange={(val: any) => multiSelectValidation(val)}
							placeholder={t('customerNum')}
							defaultValue={
								value?.length ? convertStringToArray(value) : undefined
							}
							maxTagCount={5}
							containerMaxHeight={100}
							className={Styles.ipElement}
							onBlur={() => {
								if (modeFilter) {
									if (customerNumbers?.length) {
										if(!enableMasking) validateNumbers();
										else{
											setChange({
												...change,
												customerNumValid: true,
											});
											setDisable({
												...change,
												customerNumValid: true,
											});
										}
									}
								} else {
									validateNumbers();
								}
							}}
							onDeselect={(val: any) => {
								if (customerNumbers?.length) {
									let filteredArray = customerNumbers.filter(
										(e: string) => e !== val
									);
									if (filteredArray?.length && !enableMasking) {
										if(!enableMasking) validateNumbers(filteredArray);
										else {
											setChange({
												...change,
												customerNumValid: true,
											});
											setDisable({
												...change,
												customerNumValid: true,
											});
										}
									}
								} else {
									setChange({
										...change,
										customerNumValid: true,
									});
									setDisable({
										...change,
										customerNumValid: true,
									});
								}
							}}
							bottomLabelType={
								change.hasOwnProperty('customerNumValid')
									? change['customerNumValid']
										? undefined
										: 'error'
									: undefined
							}
							bottomLabel={
								change.hasOwnProperty('customerNumValid') ? (
									change['customerNumValid'] ? undefined : (
										<span>
											<img
												style={{ marginRight: '0.5rem' }}
												src={ErrorIcon}
												className={Styles.errorIcon}
												alt=""
											/>
											{t('validCountryMsg')}
										</span>
									)
								) : undefined
							}
							showBottomLabelSpace={false}
						>
							{custData &&
								custData.map((option: any) => {
									return (
										<MultiSelectOption key={option} value={option}>
											{option}
										</MultiSelectOption>
									);
								})}
						</MultiSelect>
					)}
			</>
		);
	};

export default CustomerNumber;
